import { useContext } from "react";
import { AppContext } from "../App";
import { serviceCategories } from "./ServicesContent";

export default function HomeServicesContent() {
  const appContext = useContext(AppContext);

  return (
    <section className="vex-section vex-services-overview" data-aos="fade-up">
      <div className="container">
        <div className="vex-section-heading" data-aos="fade-up">
          <p className="vex-panel-tag">Service Categories</p>
          <h2>
            Structured supply categories with a sharper corporate presentation.
          </h2>
          <p>
            VEX is organized to make product sourcing easier, cleaner, and more
            dependable for organizations that value professional support.
          </p>
        </div>

        <div className="vex-service-grid">
          {serviceCategories.map((service, index) => (
            <article
              className="vex-service-card"
              key={service.slug}
              data-aos="fade-up"
              data-aos-delay={index * 80}
            >
              <div className="vex-service-card-body">
                <div className="vex-service-card-media">
                  <img src={service.heroImage} alt={service.title} />
                </div>
                <p className="vex-panel-tag">{service.navTitle}</p>
                <h3>{service.title}</h3>
                <p>{service.summary}</p>
                <button
                  type="button"
                  className="btn btn-link vex-inline-link"
                  onClick={() =>
                    appContext.navTo({
                      item: "services",
                      subItem: service.slug,
                    })
                  }
                >
                  View Category
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
